// AUTO-GENERATED from the Gravity Forms export (gravityforms-export-2026-09-02.json)
// and cross-checked against the live WPGraphQL response.
//
// These field definitions used to be sourced at build time via allWpGfForm.
// That is no longer possible: WordPress runs WPGraphQL 2.x, and every
// gatsby-source-wordpress version that accepts it either 500s on GfEntry or
// silently returns GfForm.formFields.nodes empty -- which renders every form
// with no fields while the build still reports success.
//
// Form SUBMISSION is unaffected: it is a runtime browser mutation against
// WPGraphQL (see contact-form.js / newsletter.js), not a build-time query.
//
// To update: re-export the forms from WordPress (Forms -> Import/Export ->
// Export Forms) and regenerate. Field `databaseId` values must match the
// WordPress field ids or submissions will be rejected.

const forms = [
  {
    "databaseId": 7,
    "formFields": {
      "nodes": [
        {
          "type": "TEXT",
          "databaseId": 2,
          "label": "First Name",
          "placeholder": "First Name",
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 3,
          "label": "Last Name",
          "placeholder": "Last Name",
          "isRequired": false
        },
        {
          "type": "EMAIL",
          "databaseId": 1,
          "label": "Email",
          "placeholder": "Your email address",
          "isRequired": true
        }
      ]
    }
  },
  {
    "databaseId": 6,
    "formFields": {
      "nodes": [
        {
          "type": "HIDDEN",
          "databaseId": 1,
          "label": "Agent",
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 4,
          "label": "Your Name",
          "placeholder": "Your Name",
          "isRequired": true
        },
        {
          "type": "EMAIL",
          "databaseId": 5,
          "label": "Your Email",
          "placeholder": "Your Email",
          "isRequired": true
        },
        {
          "type": "TEXT",
          "databaseId": 6,
          "label": "Contact Number",
          "placeholder": "Contact Number",
          "isRequired": false
        },
        {
          "type": "TEXTAREA",
          "databaseId": 7,
          "label": "Message",
          "placeholder": "Your message",
          "isRequired": false
        }
      ]
    }
  },
  {
    "databaseId": 5,
    "formFields": {
      "nodes": [
        {
          "type": "RADIO",
          "databaseId": 6,
          "label": "What can we help with?",
          "choices": [
            {
              "text": "Development Sites",
              "value": "Development Sites"
            },
            {
              "text": "Land",
              "value": "Land"
            },
            {
              "text": "House &amp; Land",
              "value": "House & Land"
            },
            {
              "text": "Sold Projects",
              "value": "Sold Projects"
            },
            {
              "text": "Marketing &amp; Sales",
              "value": "Marketing & Sales"
            },
            {
              "text": "General / Other",
              "value": "General / Other"
            }
          ],
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 1,
          "label": "Your Name",
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 3,
          "label": "Your Email",
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 4,
          "label": "Contact Number",
          "isRequired": false
        },
        {
          "type": "TEXTAREA",
          "databaseId": 5,
          "label": "Your message",
          "isRequired": false
        },
        {
          "type": "CHECKBOX",
          "databaseId": 7,
          "label": "Sidebar",
          "choices": [
            {
              "text": "I’d like a callback",
              "value": "I’d like a callback"
            },
            {
              "text": "I’d like to subscribe to Peake Project updates",
              "value": "I’d like to subscribe to Peake Project updates"
            }
          ],
          "isRequired": false
        }
      ]
    }
  },
  {
    "databaseId": 4,
    "formFields": {
      "nodes": [
        {
          "type": "RADIO",
          "databaseId": 6,
          "label": "What kind of appraisal are you looking for?",
          "choices": [
            {
              "text": "Sales Appraisal",
              "value": "Sales Appraisal"
            },
            {
              "text": "Rental Appraisal",
              "value": "Rental Appraisal"
            },
            {
              "text": "Both",
              "value": "Both"
            }
          ],
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 8,
          "label": "Please enter the address of the property you’d like us to look at.",
          "placeholder": "Property Address",
          "isRequired": false
        },
        {
          "type": "HIDDEN",
          "databaseId": 9,
          "label": "Agent Email",
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 1,
          "label": "Your Name",
          "isRequired": true
        },
        {
          "type": "TEXT",
          "databaseId": 3,
          "label": "Your Email",
          "isRequired": true
        },
        {
          "type": "TEXT",
          "databaseId": 4,
          "label": "Contact Number",
          "isRequired": false
        },
        {
          "type": "TEXTAREA",
          "databaseId": 5,
          "label": "Your comments",
          "placeholder": "Your comments (optional)",
          "isRequired": false
        },
        {
          "type": "CHECKBOX",
          "databaseId": 7,
          "label": "Sidebar",
          "choices": [
            {
              "text": "I’d like a callback",
              "value": "I’d like a callback"
            },
            {
              "text": "I’d like to subscribe to Peake updates",
              "value": "I’d like to subscribe to Peake updates"
            }
          ],
          "isRequired": false
        }
      ]
    }
  },
  {
    "databaseId": 3,
    "formFields": {
      "nodes": [
        {
          "type": "HIDDEN",
          "databaseId": 1,
          "label": "Project",
          "isRequired": false
        },
        {
          "type": "HIDDEN",
          "databaseId": 8,
          "label": "Agents",
          "isRequired": false
        },
        {
          "type": "RADIO",
          "databaseId": 3,
          "label": "What can we help with?",
          "choices": [
            {
              "text": "Technical Specs",
              "value": "Technical Specs"
            },
            {
              "text": "Projects like this one",
              "value": "Projects like this one"
            },
            {
              "text": "Pricing information",
              "value": "Pricing information"
            },
            {
              "text": "Other/General",
              "value": "Other/General"
            }
          ],
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 4,
          "label": "Your Name",
          "placeholder": "Your Name",
          "isRequired": true
        },
        {
          "type": "EMAIL",
          "databaseId": 5,
          "label": "Your Email",
          "placeholder": "Your Email",
          "isRequired": true
        },
        {
          "type": "TEXT",
          "databaseId": 6,
          "label": "Contact Number",
          "placeholder": "Contact Number",
          "isRequired": false
        },
        {
          "type": "TEXTAREA",
          "databaseId": 7,
          "label": "Message",
          "placeholder": "Your message",
          "isRequired": false
        }
      ]
    }
  },
  {
    "databaseId": 2,
    "formFields": {
      "nodes": [
        {
          "type": "HIDDEN",
          "databaseId": 1,
          "label": "Property",
          "isRequired": false
        },
        {
          "type": "HIDDEN",
          "databaseId": 8,
          "label": "Agents",
          "isRequired": false
        },
        {
          "type": "RADIO",
          "databaseId": 3,
          "label": "What can we help with?",
          "choices": [
            {
              "text": "Schedule an inspection",
              "value": "Schedule an inspection"
            },
            {
              "text": "Properties like this one",
              "value": "Properties like this one"
            },
            {
              "text": "Pricing information",
              "value": "Pricing information"
            },
            {
              "text": "Other/General",
              "value": "Other/General"
            }
          ],
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 4,
          "label": "Your Name",
          "placeholder": "Your Name",
          "isRequired": true
        },
        {
          "type": "EMAIL",
          "databaseId": 5,
          "label": "Your Email",
          "placeholder": "Your Email",
          "isRequired": true
        },
        {
          "type": "TEXT",
          "databaseId": 6,
          "label": "Contact Number",
          "placeholder": "Contact Number",
          "isRequired": false
        },
        {
          "type": "TEXTAREA",
          "databaseId": 7,
          "label": "Message",
          "placeholder": "Your message",
          "isRequired": false
        }
      ]
    }
  },
  {
    "databaseId": 1,
    "formFields": {
      "nodes": [
        {
          "type": "RADIO",
          "databaseId": 6,
          "label": "What can we help with?",
          "choices": [
            {
              "text": "Buying",
              "value": "Buying"
            },
            {
              "text": "Selling",
              "value": "Selling"
            },
            {
              "text": "Leasing",
              "value": "Leasing"
            },
            {
              "text": "Projects",
              "value": "Projects"
            },
            {
              "text": "Careers",
              "value": "Careers"
            },
            {
              "text": "General / Other",
              "value": "General / Other"
            }
          ],
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 1,
          "label": "Your Name",
          "isRequired": false
        },
        {
          "type": "EMAIL",
          "databaseId": 8,
          "label": "Your Email",
          "isRequired": false
        },
        {
          "type": "TEXT",
          "databaseId": 4,
          "label": "Contact Number",
          "isRequired": false
        },
        {
          "type": "TEXTAREA",
          "databaseId": 5,
          "label": "Your message",
          "isRequired": false
        },
        {
          "type": "CHECKBOX",
          "databaseId": 7,
          "label": "Sidebar",
          "choices": [
            {
              "text": "I’d like a callback",
              "value": "I’d like a callback"
            },
            {
              "text": "I’d like to subscribe to Peake updates",
              "value": "I’d like to subscribe to Peake updates"
            }
          ],
          "isRequired": false
        }
      ]
    }
  }
]

export default forms
